import styled from "styled-components"

const CountdownContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
`

const CountdownInfo = styled.p`
  font-size: 1.1rem;
  text-align:center;
`

const CountdownSquare = styled.div`
  text-align: center;
  padding: 1rem;
  border-radius: 4px;
`

const CountdownText = styled.span`
  display: block;
  margin-top: 0.3rem;
  text-transform: uppercase;
  text-align: center;
`

export { CountdownContainer, CountdownText, CountdownSquare, CountdownInfo }
